import { getSubjectColorIndex } from "@/lib/strapi/formatters";
import {
  buildFullPath,
  getAllowedResourcesForSubject,
} from "@/lib/utils/routing";
import { Resources } from "@/types/subject-schema";
import TabsComponent from "./TabsComponent";

export default function ResourceTabs({
  subjectNameLower,
  currentResource,
}: {
  subjectNameLower: string;
  currentResource: Resources | "all";
}) {
  const subjectColorIndex = getSubjectColorIndex(subjectNameLower);
  const resourcesToShow: {
    resource: Resources | "all";
    label: string;
    value: string;
  }[] = [
    {
      resource: "all",
      label: "All resources",
      value: buildFullPath({
        subject: subjectNameLower,
        resource: "all",
      }),
    },
    {
      resource: "syllabus",
      label: "Syllabus checklist",
      value: buildFullPath({
        subject: subjectNameLower,
        resource: "syllabus",
      }),
    },
    {
      resource: "exam breakdown",
      label: "Exam breakdown",
      value: buildFullPath({
        subject: subjectNameLower,
        resource: "exam breakdown",
      }),
    },
    {
      resource: "videos",
      label: "Videos",
      value: buildFullPath({
        subject: subjectNameLower,
        resource: "videos",
      }),
    },
    {
      resource: "notes",
      label: "Notes",
      value: buildFullPath({
        subject: subjectNameLower,
        resource: "notes",
      }),
    },
    {
      resource: "definitions",
      label: "Definitions",
      value: buildFullPath({
        subject: subjectNameLower,
        resource: "definitions",
      }),
    },
    {
      resource: "flashcards",
      label: "Flashcards",
      value: buildFullPath({
        subject: subjectNameLower,
        resource: "flashcards",
      }),
    },
    {
      resource: "questions",
      label: "Questions",
      value: buildFullPath({
        subject: subjectNameLower,
        resource: "questions",
      }),
    },
    {
      resource: "cram sheets",
      label: "Cram sheets",
      value: buildFullPath({
        subject: subjectNameLower,
        resource: "cram sheets",
      }),
    },
    {
      resource: "exam tests",
      label: "Tests",
      value: buildFullPath({
        subject: subjectNameLower,
        resource: "exam tests",
      }),
    },
    {
      resource: "ia examples",
      label: "IA examples",
      value: buildFullPath({
        subject: subjectNameLower,
        resource: "ia examples",
      }),
    },
    {
      resource: "ia criteria",
      label: "IA criteria",
      value: buildFullPath({
        subject: subjectNameLower,
        resource: "ia criteria",
      }),
    },
    {
      resource: "command terms",
      label: "Command terms",
      value: buildFullPath({
        subject: subjectNameLower,
        resource: "command terms",
      }),
    },
  ];

  return (
    <TabsComponent
      type={"resource"}
      tabs={filterResourcesToShow(subjectNameLower, resourcesToShow)}
      subjectColorIndex={subjectColorIndex}
      activeTabValue={buildFullPath({
        subject: subjectNameLower,
        resource: currentResource,
      })}
    />
  );
}

function filterResourcesToShow(
  subjectNameLower: string,
  resourcesToShow: {
    resource: Resources | "all";
    label: string;
    value: string;
  }[]
) {
  const allowedResources = new Set(getAllowedResourcesForSubject(subjectNameLower));
  return resourcesToShow.filter(
    (resource) =>
      resource.resource === "all" || allowedResources.has(resource.resource)
  );
}
